import React from 'react';
import { Card, CardContent, Badge } from '@/components/ui';

export interface ScheduleItem {
  id: string;
  timeRange: string;
  task: string;
  location: string;
  status: 'completed' | 'in_progress' | 'pending';
}

interface DailyScheduleProps {
  items?: ScheduleItem[];
  isLoading?: boolean;
}

export function DailySchedule({ items, isLoading }: DailyScheduleProps) {
  const defaultItems: ScheduleItem[] = [
    { id: '1', timeRange: '07:30 - 09:00', task: 'Trồng cây bụi, cây nền', location: 'Khu A - Tuyến 1', status: 'completed' },
    { id: '2', timeRange: '09:00 - 11:00', task: 'Trải đất màu, san nền', location: 'Khu A - Tuyến 2', status: 'completed' },
    { id: '3', timeRange: '13:30 - 15:30', task: 'Lắp đặt hệ thống tưới', location: 'Khu A - Tuyến 1', status: 'in_progress' },
    { id: '4', timeRange: '15:30 - 17:00', task: 'Lắp đặt đèn chiếu sáng', location: 'Khu A - Tuyến 3', status: 'pending' },
    { id: '5', timeRange: '17:00 - 18:00', task: 'Vệ sinh, dọn dẹp hiện trường', location: 'Toàn tuyến', status: 'pending' },
  ];

  const displayItems = items || defaultItems;

  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'completed': return { label: 'Hoàn thành', color: 'bg-emerald-50 text-emerald-600 border-emerald-100', dot: 'bg-emerald-600' };
      case 'in_progress': return { label: 'Đang thực hiện', color: 'bg-blue-50 text-blue-600 border-blue-100', dot: 'bg-blue-600' };
      default: return { label: 'Chờ thực hiện', color: 'bg-orange-50 text-orange-600 border-orange-100', dot: 'bg-orange-400' };
    }
  };

  return (
    <Card className="border-none shadow-sm h-full">
      <CardContent className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-sm font-bold text-slate-800">Lịch thi công hôm nay (15/05/2024)</h3>
          <button className="text-[10px] font-bold text-emerald-600 hover:underline">Xem tất cả</button>
        </div>

        <div className="relative space-y-6 before:absolute before:left-[4px] before:top-2 before:bottom-2 before:w-px before:bg-slate-100">
          {displayItems.map((item) => {
            const config = getStatusConfig(item.status);
            return (
              <div key={item.id} className="relative pl-6 flex justify-between items-start">
                <div className={`absolute left-0 top-1.5 w-2 h-2 rounded-full ${config.dot} z-10`} />
                <div className="flex gap-4">
                  <span className="text-[10px] font-bold text-slate-400 w-24 shrink-0">{item.timeRange}</span>
                  <div className="space-y-1">
                    <p className="text-xs font-bold text-slate-700 leading-tight">{item.task}</p>
                    <p className="text-[10px] font-medium text-slate-400 italic">{item.location}</p>
                  </div>
                </div>
                <Badge variant="outline" className={`sm:text-sm text-xs font-normal px-2 py-0.5 rounded-md border ${config.color}`}>
                  {config.label}
                </Badge>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
